import { Navigate } from 'react-router-dom';
import { JSX } from 'react/jsx-runtime';
import { useAircraft } from './aircraft/AircraftContext';
import { useAuth } from './auth/AuthContext';

const ProtectedRoute = ({
  children,
  requireAircraft = true,
  denyGuest = false,
  denyTechnician = false,
  requireFlyOrBook = false,
}: {
  children: JSX.Element;
  /** Пока в клубе нет борта — пускаем только на /aircraft. */
  requireAircraft?: boolean;
  /** Гостю закрыто (личный кабинет, создание клуба). */
  denyGuest?: boolean;
  /** Технику закрыто (создание клуба). */
  denyTechnician?: boolean;
  /** Только owner/admin/pilot (добавление полёта и брони). */
  requireFlyOrBook?: boolean;
}) => {
  const { isAuthenticated, loading, isGuest, isTechnician, canFlyOrBook } =
    useAuth();
  const { aircraftList, loading: aircraftLoading } = useAircraft();

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireFlyOrBook && !canFlyOrBook) {
    return <Navigate to="/" replace />;
  }

  if (denyGuest && isGuest) {
    return <Navigate to="/" replace />;
  }

  if (denyTechnician && isTechnician) {
    return <Navigate to="/" replace />;
  }

  if (requireAircraft) {
    if (aircraftLoading && aircraftList.length === 0) {
      return null;
    }
    if (aircraftList.length === 0) {
      return <Navigate to="/club" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
